module.exports = __webpack_public_path__ + "img/watermark.bd812564.svg";